export class AsyncLoaded<T> {
  data: T | null;
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
  error: string | null;

  constructor() {
    this.data = null;
    this.status = 'idle';
    this.error = null;
  }

  withLoading() {
    const newState = new AsyncLoaded<T>();
    newState.status = 'loading';
    return newState;
  }

  withSucceeded(value: T) {
    const newState = new AsyncLoaded<T>();
    newState.data = value;
    newState.status = 'succeeded';
    return newState;
  }

  withFailed(message: string) {
    const newState = new AsyncLoaded<T>();
    newState.status = 'failed';
    newState.error = message;
    return newState;
  }

  isPending() {
    return ['idle', 'loading'].includes(this.status)
  }
}

export class AsyncLoadedArray<T> {
  data: T[] | null;
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
  error: string | null;

  constructor() {
    this.data = null;
    this.status = 'idle';
    this.error = null;
  }

  withLoading() {
    const newState = new AsyncLoadedArray<T>();
    newState.status = 'loading';
    return newState;
  }

  withSucceeded(value: T[]) {
    const newState = new AsyncLoadedArray<T>();
    newState.data = value;
    newState.status = 'succeeded';
    return newState;
  }

  withFailed(message: string) {
    const newState = new AsyncLoadedArray<T>();
    newState.status = 'failed';
    newState.error = message;
    return newState;
  }

  dataOrEmpty(): T[] {
    return this.data ?? []
  }

  isPending() {
    return ['idle', 'loading'].includes(this.status)
  }
}
